import { toast } from 'react-toastify';
import { client, flattenItem, flattenItems } from './contentful';
import * as twApi from './tw-api';
import { TURBINE_ADMIN_EMAIL } from '../constants/globals';
import isPublished from '../utils/isPublished';

export const fetchCourse = (id) => {
  return new Promise((resolve, reject) => {
    client
      .getEntry(id)
      .then((response) => {
        const course = isPublished(response) ? flattenItem(response) : null;

        resolve(course);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const fetchCourses = ({ orgId, select }) => {
  const config = {
    content_type: 'class',
    include: 1,
    'fields.orgId': orgId
  };

  if (select) {
    config.select = select.join(',');
  }

  return new Promise((resolve, reject) => {
    client
      .getEntries(config)
      .then(({ items }) => {
        const courses = items.length ? flattenItems(items) : null;

        resolve(courses);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const fetchSyndicatedCourses = ({ orgIds, select }) => {
  const config = {
    content_type: 'class',
    include: 1,
    'fields.orgIds[in]': orgIds.join(',')
  };

  if (select) {
    config.select = select.join(',');
  }

  return new Promise((resolve, reject) => {
    client
      .getEntries(config)
      .then(({ items }) => {
        const syndicatedCourses = items.length ? flattenItems(items) : null;

        resolve(syndicatedCourses);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

/**
 * Invites users to onboard by sending an invite that contains a link to register
 * @param {string} emails // 'alan.mabry@gmail.com' comma separated emails
 * @param {string} link
 * @returns {Promise<string>} emails, link
 */
export const inviteUsers = ({ emails, link, orgName, orgEmail }) => {
  return new Promise((resolve, reject) => {
    // Turbine gmail api
    const to = orgEmail || TURBINE_ADMIN_EMAIL;
    const emailParts = {
      to,
      from: {
        name: orgName
      },
      replyTo: to,
      bcc: emails,
      subject: `Invitation to Join ${orgName}`,
      body: '',
      htmlBody: `<p>You've been invited to join ${orgName}'s portal. Click the link below:</p> <br/> ${link}`
    };

    return twApi
      .post('/v1/external/gmail/send', '', JSON.stringify(emailParts))
      .then((response) => {
        if (response && response.status === 200) {
          toast.success('Invitations sent!');
          resolve({ emails, link });
        } else {
          toast.error(response.message); // ex: 'Something went wrong, try again'
          console.error(response.status); // ex: 'error_invitation_fail'

          reject({
            message: response.message,
            status: response.status
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });
};

export const routeWithClassId = (route, classId) =>
  `${route}?classId=${classId}`;
